import React from "react";
import styled from "styled-components";
import CheckmarkFilled16 from '@carbon/icons-react/lib/checkmark--filled/16';
import CheckmarkOutline16 from '@carbon/icons-react/lib/checkmark--outline/16';
import { ScrollingProvider, Section, SectionLink } from '../../lib/react-scroll-section/src/index'
import Radio16 from '@carbon/icons-react/lib/radio-button/16'

//const Menu = styled.ul`
//  position: fixed;
//  z-index: 1;
//  left: 50%;
//  transform: translateX(-50%);
//  display: table;
//  margin-left: auto;
//  margin-right: auto;
//  margin: 0;
//`;

//const Item = styled.li`
//  display: inline-block;
//  text-align: center;
//  cursor: pointer;
//  transition: all 0.25s;
//  margin: 0;
//  padding: 40px 10px;
//  font-weight: bold;
//  font-size: 20px;
//  user-select: none;
//  color: ${props => (props.selected ? "#07689f" : "inherit")};
//  border-top: 5px solid ${props =>
//        props.selected ? "#ff7e67" : "transparent"};
//`;

const Menu = ({ children }) => (
    <ul data-progress data-progress-current className="bx--progress bx--progress--vertical">
        {children}
    </ul>
);

const Item = ({ section, children }) => (
    <SectionLink section={section}>
        {link => (
            <li onClick={link.onClick} selected={link.isSelected} className={link.isSelected ? 'bx--progress-step bx--progress-step--complete' : 'bx--progress-step'}>
                <Radio16 className={link.isSelected ?  'bx--progress-step--indicator' : null} />
                <p tabIndex="0" className="bx--progress-label ">
                    {children}
                </p>
                <div id="label-tooltip" role="tooltip" data-floating-menu-direction="bottom" className="bx--tooltip" data-avoid-focus-on-open>
                    <p className="bx--tooltip__text"></p>
                </div>

                <span className="bx--progress-line"></span>
            </li>
        )}
    </SectionLink>
);

export { Item, Menu };

export default styled;
